import { Url } from "../api_settings/api_constants";
import { wrappedGet } from "../api_settings/urlFunctions";

//Get Page Content
export const getContent = (slug) => {
    return wrappedGet(Url.GET_PAGE + slug, "GET");
};
